import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export const expensesColumns = [
	{
		title: 'Particulars',
		dataIndex: 'particular',
		key: 'particular',
		width: 200,
		render: (text) => (
			<Text
				style={{
					fontWeight: 500,
					color: '#000',
				}}
			>
				{text || '-'}
			</Text>
		),
	},
	{
		title: 'Client Rate',
		dataIndex: 'client_rate',
		key: 'client_rate',
		width: 120,
		render: (amount) => (
			<Text style={{ fontWeight: 600, color: '#52c41a' }}>
				₹{amount ? parseFloat(amount).toFixed(2) : '0.00'}
			</Text>
		),
	},
	{
		title: 'Vendor Rate',
		dataIndex: 'vendor_rate',
		key: 'vendor_rate',
		width: 120,
		render: (amount) => (
			<Text style={{ fontWeight: 600, color: '#fa8c16' }}>
				₹{amount ? parseFloat(amount).toFixed(2) : '0.00'}
			</Text>
		),
	},
	{
		title: 'Margin',
		dataIndex: 'margin',
		key: 'margin',
		width: 120,
		render: (amount) => (
			<Text style={{ fontWeight: 600, color: '#1890ff' }}>
				₹{amount ? parseFloat(amount).toFixed(2) : '0.00'}
			</Text>
		),
	},
	{
		title: 'Percentage (%)',
		dataIndex: 'percentage',
		key: 'percentage',
		width: 100,
		render: (percentage) => (
			<Text style={{ fontWeight: 500, color: '#666' }}>
				{percentage ? `${percentage.toFixed(2)}%` : '-'}
			</Text>
		),
	},
];
